import { getVisibleNodes as e } from "./helpers/getVisibleNodes.js";
import { getLeafNodeIds as t, hasChildren as n } from "./helpers/selectionProcessing.js";
import { useTreeExpansion as r } from "./hooks/useTreeExpansion.js";
import { TreeNodeElement as i } from "./TreeNodeElement/TreeNodeElement.js";
import { TreeSkeleton as a } from "./TreeSkeleton/TreeSkeleton.js";
import o from "./Tree.module.js";
import s from "classnames";
import { useRef as c } from "react";
import { jsx as l } from "react/jsx-runtime";
import { useVirtualizer as u } from "@tanstack/react-virtual";
//#region src/components/Tree/Tree.tsx
var d = 36, f = (f) => {
	let { className: p, data: m, defaultExpandedIds: h = [], resetExpandedOnDataChange: g = !0, selection: _, search: v, searchExpandedIds: y, isLoading: b, onSelectionChange: x, onItemExpansionChange: S, expandedIds: C, onExpandedIdsChange: w, onItemSelect: T } = f, { expandedIds: E, setExpandedIds: D } = r({
		data: m,
		defaultExpandedIds: h,
		search: v,
		searchExpandedIds: y,
		resetKey: g ? m : void 0
	}), O = C ?? E, k = c(null), A = (e) => {
		let { id: t } = e, n = new Set(O), r = !n.has(t);
		r ? n.add(t) : n.delete(t), C === void 0 && D(n), w?.(n), S?.(e, r);
	}, j = (e, r) => {
		T?.(e, r);
		let i = n(e), a = i ? t([e]) : [e.id], o = Array.from(a).reduce((t, n) => ((e.selectable || i) && (r ? t.add(n) : t.delete(n)), t), new Set(_));
		x?.(o);
	}, M = e(m, O), N = u({
		count: M.length,
		estimateSize: () => d,
		getItemKey: (e) => M[e].node.id,
		getScrollElement: () => k.current,
		overscan: 10
	});
	return /* @__PURE__ */ l("div", {
		ref: k,
		className: s(o.tree, p, { [o.loading]: b }),
		children: b ? /* @__PURE__ */ l(a, {}) : /* @__PURE__ */ l("div", {
			className: o.items,
			style: { height: N.getTotalSize() },
			children: N.getVirtualItems().map(({ index: e, key: t, start: n }) => {
				let { depth: r, node: a } = M[e];
				return /* @__PURE__ */ l("div", {
					ref: N.measureElement,
					className: o.item,
					"data-index": e,
					style: { transform: `translateY(${n}px)` },
					children: /* @__PURE__ */ l(i, {
						depth: r,
						node: a,
						selection: _,
						expandedIds: O,
						onExpandToggle: A,
						onSelect: j,
						search: v
					})
				}, t);
			})
		})
	});
};
//#endregion
export { f as Tree };
